import {
  AUDIT_LOG_FETCH_REQUEST,
  AUDIT_LOG_FETCH_REQUEST_SUCCESS,
  AUDIT_LOG_FETCH_REQUEST_FAILURE,
  AUDIT_LOG_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const auditLogReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case AUDIT_LOG_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case AUDIT_LOG_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data || action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          showSizeChanger: true,
        },
      });

    case AUDIT_LOG_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case AUDIT_LOG_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export default auditLogReducer;
